export const TimeEnum = Object.freeze({
  NOW: "now",
  ALL: "all",
  TODAY: "today",
  LAST_WEEK: "lastWeek",
  LAST_MONTH: "lastMonth",
  LAST_QUARTER: "lastQuarter",
  LAST_YEAR: "lastYear",
  CUSTOM: "custom"
});

export const TimeTypeEnum = Object.freeze({
  "submission-time": "Submission Time",
  firstseen: "First Seen",
  lastseen: "Last Seen"
});

export const TimePeriodEnum = Object.freeze({
  now: "Now",
  all: "All",
  today: "Today",
  lastWeek: "Last Week",
  lastMonth: "Last Month",
  lastQuarter: "Last Quarter",
  lastYear: "Last Year",
  custom: "Custom"
});

export const UriTypeEnum = Object.freeze({
  DOMAIN_NAME: "Domain",
  UNKNOWN: "Unknown",
  URL: "Link",
  IP: "IP"
});

export const HashTypeEnum = Object.freeze({
  SHA1: "sha1",
  SHA256: "sha256",
  MD5: "md5"
});

export const UriSourceEnum = Object.freeze({
  MALWARE_CONFIG: "mwconfig",
  STATIC: "static",
  DYNAMIC: "dynamic"
});

export const EmailTypeEnum = Object.freeze({
  FROM: "From",
  TO: "To"
});

export const EmailPivotingEnum = Object.freeze({
  ADDRESS: "Pivot by Email Address",
  SUBJECT: "Pivot by Email Subject"
});

export const EmailClassificationEnum = Object.freeze({
  ALL_CLASSIFIED: "All Classified",
  GOODWARE: "Goodware",
  MALICIOUS: "Malicious",
  SUSPICIOUS: "Suspicious",
  UNKNOWN: "Unknown (No Threats Found)"
});

export const YaraRulesetEnum = Object.freeze({
  favorite: "Favorite",
  last_matched: "Last Matched"
});

export const YaraMatchesEnum = Object.freeze({
  all: "All",
  local: "Local",
  cloud: "Cloud",
  "local-retro": "Local Retro",
  "cloud-retro": "Cloud Retro"
});

export const AnalysisStatus = Object.freeze({
  UPLOADING: "Uploading",
  ANALYZING: "Analyzing",
  QUEUED: "Queued",
  PROCESSING: "Processing",
  REANALYZING: "Reanalyzing",
  FAILED_UPLOAD: "Failed upload",
  PROCESSING_ERROR: "Processing error"
});

export const AnalysisButtonText = Object.freeze({
  CONFIGURE: "Configure",
  UPLOAD: "Upload",
  ANALYZE: "Analyze",
  REANALYZE: "Reanalyze"
});

export const AnalysisAdditionalInfo = Object.freeze({
  PROCESSING: "Sample is being processed",
  NOT_CONFIGURED: "NOT CONFIGURED",
  FILE_OVERSIZED: "FILE OVERSIZED",
  NEVER_SUBMITED: "Sample was never submitted",
  NOT_SUPPORTED: "FILE TYPE NOT SUPPORTED"
});

export const AnalyzerInfo = Object.freeze({
  FILE_ANALYZER: 0,
  URL_ANALYZER: 1
});

export const UrlScraper = Object.freeze({
  LOCAL: "local",
  TI_CLOUD: "cloud"
});

export const SubmitUrlModalDefaultMessages = {
  tiCloudDisabled:
    "In order to use this functionality you must have a Spectra Intelligence account.",
  success: "URL successfully submitted for analysis.",
  error: "Unexpected error while submitting URL for analysis.",
  interactiveAnalysisError:
    "There was en error while trying to start Interactive URL analysis."
};

export const NotificationsLevel = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info"
});

export const ProcessingStatusEnum = Object.freeze({
  unprocessed: "Unprocessed",
  processing: "Processing",
  processed: "Processed",
  error: "Error"
});

export const TimeRangeEnum = Object.freeze({
  all: "All",
  custom: "Custom",
  today: "Today",
  lastWeek: "Last Week",
  lastMonth: "Last Month",
  lastQuarter: "Last 3 Months",
  lastYear: "Last Year"
});

export const ClassificationEnum = Object.freeze({
  unknown: "Unknown (No threats found)",
  goodware: "Goodware",
  suspicious: "Suspicious",
  malicious: "Malicious"
});

export const CloudSearchTypeEnum = Object.freeze({
  all: "All",
  private: "Private",
  public: "Public"
});

export const NetworkResourceEnum = Object.freeze({
  all: "All",
  domain: "Domain",
  url: "URL",
  ip: "IP"
});

export const HistoryItemKeyEnum = {
  classification: "Classification",
  firstseen: "First Seen",
  lastseen: "Last Seen",
  "processing-status": "Processing Status",
  "submission-user": "Submission User",
  "submission-time": "Submission Time",
  time_type: "Time type",
  period_type: "Period Type",
  cloud_search_type: "Cloud Search Type",
  sample_origin: "Sample Origin",
  network_resource: "Resource Type"
};

export const SearchEnums = {
  classification: ClassificationEnum,
  firstseen: TimeRangeEnum,
  lastseen: TimeRangeEnum,
  period_type: TimeRangeEnum,
  "processing-status": ProcessingStatusEnum,
  "submission-time": TimeRangeEnum,
  time_type: HistoryItemKeyEnum,
  cloud_search_type: CloudSearchTypeEnum,
  network_resource: NetworkResourceEnum
};
